// These are the settings specific to staging mode
// Staging is a pixel-identical copy of prod pointing at the staging backend:
// no dev tools and no GTM (so it never pollutes the prod GA4 property), but Rollbar stays on.

// No trailing slash !
const YOPLANNING_ROOT_URL = 'https://staging-dot-yoplanning-gcp.oa.r.appspot.com';

export const SETTINGS_STAGING = {
  YOPLANNING_ROOT_URL: YOPLANNING_ROOT_URL,
  BOOKING_ENGINE_ROOT_URL: `${YOPLANNING_ROOT_URL}/booking-engine`, // No trailing slash !

  IS_DEV: false,
  SHOW_DEV_TOOLS: false,
  ROLLBAR_ENABLED: true,
  GTM_ENABLED: false,

  ROLLBAR_ENV_NAME: 'staging',
};
